import * as api from '../api';
import { participantTypeHelpers } from '../participant-types';

const fetchTouchpointPermissionsActions = api.fetchActions('permissions', 'fetch-touchpoint-permissions');
const submitTouchpointPermissionsActions = api.fetchActions('permissions', 'submit-touchpoint-permissions');
export const submitDemographicsEnabledStatusActions = api.fetchActions('permissions', 'submit-demographics-enabled-status');

export const actionTypes = {
  ...fetchTouchpointPermissionsActions.actionTypes,
  ...submitTouchpointPermissionsActions.actionTypes,
  ...submitDemographicsEnabledStatusActions.actionTypes,
  UPDATE_PROGRAM_TP_PERMISSIONS: 'permissions.update-program-touchpoint-permissions',
  OPEN_ENABLE_DEMOGRAPHICS_MODAL: 'permissions.open-enable-demographics-modal',
  CLOSE_ENABLE_DEMOGRAPHICS_MODAL: 'permissions.close-enable-demographics-modal',
  OPEN_DISABLE_DEMOGRAPHICS_MODAL: 'permissions.open-disable-demographics-modal',
  CLOSE_DISABLE_DEMOGRAPHICS_MODAL: 'permissions.close-disable-demographics-modal',
  UPDATE_MODAL_OPTION: 'permissions.update-modal-option',
  UPDATE_DEMOGRAPHICS_CHECKBOX: 'permissions.update-demographics-checkbox'
}

function shouldFetchTouchpointPermissions(state, siteId)
{
  const { permissions } = state;
  const { permissionsData } = permissions;
  const permissionsState = permissionsData.get(siteId);
  return !permissionsState || !(permissionsState.isFetching || permissionsState.isValid);
}

export function fetchTouchpointPermissions(siteId) {
  return (dispatch, getState) => {
    const state = getState();
    const { permissions } = state;
    const { permissionsData } = permissions;
    const permissionsState = permissionsData.get(siteId);
    if(shouldFetchTouchpointPermissions(state, siteId)) {
      var params = {
        participantTypeId: participantTypeHelpers.getParticipantTypeId(),
        siteId,
      };
      return dispatch(api.getThunk(`/touchpoint-permissions/GetTouchpointPermissions`, params, fetchTouchpointPermissionsActions, {siteId}));
    }
    else {
      return Promise.resolve(permissionsState.permissions);
    }
  }
}

function shouldSubmitTouchpointPermissions(state, siteId)
{
  const { permissions } = state;
  const { permissionsSubmission } = permissions;
  const submissionState = permissionsSubmission.get(siteId);
  return !submissionState || !submissionState.isSubmitting;
}

export function submitTouchpointPermissions(siteId) {
  return (dispatch, getState) => {
    const state = getState();
    const { permissions } = state;
    const { permissionsResponse, permissionsSubmission } = permissions;

    if(shouldSubmitTouchpointPermissions(state, siteId)) {
      var touchpointPermissions = [];
      const siteResponses = permissionsResponse.get(siteId);
      siteResponses && siteResponses.forEach((formResponse, formId) => {
        formResponse.forEach((programResponse, programId) => {
          touchpointPermissions.push({
            siteId,
            programId,
            touchpointId: formId,
            view: programResponse.get('view'),
            add: programResponse.get('add'),
            edit: programResponse.get('edit')
          });
        });
      });

      const request = {
        participantTypeId: participantTypeHelpers.getParticipantTypeId(),
        permissionResponses: touchpointPermissions,
      }

      return dispatch(api.postThunk(`/touchpoint-permissions/SaveTouchpointPermissions`, request, submitTouchpointPermissionsActions, {siteId}));
    }
    else {
      return Promise.resolve(permissionsSubmission.data);
    }
  }
}

export function updateProgramTouchpointPermissions(siteId, touchpointFormId, programId, section, value) {
  return {
    type: actionTypes.UPDATE_PROGRAM_TP_PERMISSIONS,
    siteId,
    touchpointFormId,
    programId,
    section,
    value
  }
}

export function openEnableDemographicsModal() {
  return {
    type : actionTypes.OPEN_ENABLE_DEMOGRAPHICS_MODAL,
  }
}

export function closeEnableDemographicsModal() {
  return {
    type : actionTypes.CLOSE_ENABLE_DEMOGRAPHICS_MODAL,
  }
}

export function openDisableDemographicsModal() {
  return {
    type : actionTypes.OPEN_DISABLE_DEMOGRAPHICS_MODAL,
  }
}

export function closeDisableDemographicsModal() {
  return {
    type : actionTypes.CLOSE_DISABLE_DEMOGRAPHICS_MODAL,
  }
}

export function updateModalOption(value) {
  return {
    type : actionTypes.UPDATE_MODAL_OPTION,
    value
  }
}

export function updateDemographicsCheckbox(value) {
  return {
    type : actionTypes.UPDATE_DEMOGRAPHICS_CHECKBOX,
    value
  }
}

export function submitDemographicsEnabledStatus(status) {
  return (dispatch) => {
    const request = {
      participantTypeId: participantTypeHelpers.getParticipantTypeId(),
      enabled: status,
    };
    return dispatch(api.postThunk(`/demographics-permissions/update-enabled-status`,
      request, submitDemographicsEnabledStatusActions));
  }
}
